import React from 'react';
import PropTypes from 'prop-types';

const SVG = ({ icon }) => {
  switch (icon) {
    case 'menu':
      return (
        <svg fill="#000000" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
        </svg>
      );
    case 'devices':
      return (
        <svg fill="#000000" viewBox="0 0 24 24" width="50" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z" />
        </svg>
      );
    case 'code':
      return (
        <svg fill="#000000" viewBox="0 0 24 24" width="50" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0h24v24H0V0z" fill="none" />
          <path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z" />
        </svg>
      );
    case 'cms':
      return (
        <svg fill="#000000" viewBox="0 0 24 24" width="50" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 18h5v-6h-5v6zm-6 0h5V5H4v13zm12 0h5v-6h-5v6zM10 5v6h11V5H10z" />
          <path d="M0 0h24v24H0z" fill="none" />
        </svg>
      );
    case 'tool':
      return (
        <svg fill="#000000" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
          <path clipRule="evenodd" d="M0 0h24v24H0z" fill="none" />
          <path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z" />
        </svg>
      );
    case 'link':
      return (
        <svg fill="#000000" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" />
        </svg>
      );
    case 'github':
      return (
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" viewBox="0 0 12 14">
          <path d="M4.055 9.375q0.031-0.047-0.023-0.102-0.070-0.055-0.109-0.016-0.031 0.047 0.023 0.102 0.070 0.055 0.109 0.016zM3.836 9.055q-0.039-0.055-0.094-0.031-0.047 0.031 0 0.094 0.055 0.062 0.094 0.039 0.047-0.031 0-0.102zM3.516 8.742q0.016-0.031-0.039-0.062-0.055-0.016-0.062 0.016-0.023 0.039 0.031 0.062 0.062 0.016 0.070-0.016zM3.68 8.922q0.016-0.008 0.012-0.035t-0.027-0.043q-0.047-0.055-0.078-0.023t0.008 0.086q0.047 0.047 0.086 0.016zM4.352 9.508q0.016-0.055-0.070-0.086-0.070-0.023-0.102 0.031-0.016 0.055 0.070 0.086 0.070 0.023 0.102-0.031zM4.68 9.531q0-0.062-0.094-0.062-0.078 0-0.078 0.062t0.086 0.062 0.086-0.062zM4.984 9.477q-0.016-0.055-0.102-0.039t-0.070 0.070q0.016 0.062 0.094 0.047t0.078-0.078zM10 7q0-1.656-1.172-2.828t-2.828-1.172-2.828 1.172-1.172 2.828q0 1.305 0.766 2.348t1.969 1.449q0.141 0.023 0.207-0.039t0.066-0.156q0-0.406-0.008-0.742-0.047 0.008-0.121 0.020t-0.277 0.016-0.375-0.031-0.34-0.156-0.23-0.324q-0.18-0.461-0.445-0.578-0.016-0.008-0.035-0.027l-0.062-0.062t-0.055-0.074 0.031-0.059 0.152-0.027q0.047 0 0.117 0.016t0.234 0.121 0.258 0.277q0.125 0.219 0.293 0.328t0.34 0.109 0.297-0.027 0.234-0.074q0.055-0.367 0.258-0.539-0.383-0.047-0.672-0.145t-0.57-0.305-0.434-0.594-0.152-0.934q0-0.617 0.414-1.070-0.187-0.484 0.039-1.062 0.148-0.047 0.426 0.059t0.473 0.23l0.203 0.125q0.453-0.133 1-0.133t1 0.133q0.086-0.055 0.223-0.141t0.434-0.203 0.445-0.070q0.227 0.578 0.039 1.062 0.414 0.453 0.414 1.070 0 0.445-0.109 0.785t-0.277 0.547-0.418 0.348-0.488 0.203-0.535 0.094q0.273 0.242 0.273 0.742 0 0.312-0.004 0.695t-0.004 0.398q0 0.094 0.066 0.156t0.207 0.039q1.203-0.406 1.969-1.449t0.766-2.348zM12 3.25v7.5q0 0.93-0.66 1.59t-1.59 0.66h-7.5q-0.93 0-1.59-0.66t-0.66-1.59v-7.5q0-0.93 0.66-1.59t1.59-0.66h7.5q0.93 0 1.59 0.66t0.66 1.59z" />
        </svg>
      );
    case 'linkedin':
      return (
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" viewBox="0 0 12 14">
          <path d="M1.852 11.047h1.805v-5.422h-1.805v5.422zM3.773 3.953q-0.008-0.406-0.281-0.672t-0.727-0.266-0.738 0.266-0.285 0.672q0 0.398 0.277 0.668t0.723 0.27h0.008q0.461 0 0.742-0.27t0.281-0.668zM8.344 11.047h1.805v-3.109q0-1.203-0.57-1.82t-1.508-0.617q-1.062 0-1.633 0.914h0.016v-0.789h-1.805q0.023 0.516 0 5.422h1.805v-3.031q0-0.297 0.055-0.438 0.117-0.273 0.352-0.465t0.578-0.191q0.906 0 0.906 1.227v2.898zM12 3.25v7.5q0 0.93-0.66 1.59t-1.59 0.66h-7.5q-0.93 0-1.59-0.66t-0.66-1.59v-7.5q0-0.93 0.66-1.59t1.59-0.66h7.5q0.93 0 1.59 0.66t0.66 1.59z" />
        </svg>
      );
    case 'loading':
      return (
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 14 14">
          <path d="M13.75 7q0 1.375-0.535 2.625t-1.438 2.152-2.152 1.438-2.625 0.535-2.625-0.535-2.152-1.438-1.438-2.152-0.535-2.625q0-1.664 0.758-3.113t2.070-2.387 2.922-1.18v1.781q-1.727 0.352-2.863 1.727t-1.137 3.172q0 1.016 0.398 1.941t1.066 1.594 1.594 1.066 1.941 0.398 1.941-0.398 1.594-1.066 1.066-1.594 0.398-1.941q0-1.797-1.137-3.172t-2.863-1.727v-1.781q1.609 0.242 2.922 1.18t2.070 2.387 0.758 3.113z" />
        </svg>
      );
    case 'email':
      return (
        <svg
          fill="#000000"
          viewBox="0 0 24 24"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
          strokeWidth="0.5"
        >
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z" />
        </svg>
      );
    case 'user':
    default:
      return (
        <svg
          fill="#000000"
          height="24"
          viewBox="0 0 24 24"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
          strokeWidth="0.5"
        >
          <path d="M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z" />
          <path d="M0 0h24v24H0z" fill="none" />
        </svg>
      );
  }
};

SVG.propTypes = {
  icon: PropTypes.string.isRequired,
};

export default SVG;



// WEBPACK FOOTER //
// ./src/components/partials/SVG.jsx